import { render, staticRenderFns } from "./doc_viewer_report.vue?vue&type=template&id=27639ae1&scoped=true"
import script from "./doc_viewer_report.vue?vue&type=script&lang=js"
export * from "./doc_viewer_report.vue?vue&type=script&lang=js"
import style0 from "./doc_viewer_report.vue?vue&type=style&index=0&id=27639ae1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27639ae1",
  null
  
)

export default component.exports